angular.module('ihestiaCommonDirectives.filters', [
  'ihestiaCommonDirectives.tryEscapeHtml',
  'lsnBase.filters'
  ]);